export default __webpack_public_path__ + "static/media/008-egg rolls.054e7a8d.svg";